import { Navigate, useParams } from 'react-router';
import PageShell from '@components/pages/PageShell';
import {
    InnovationHero,
    InnovationAbout,
    InnovationFeatures,
    InnovationCTA,
} from '@components/pages/InnovationSections';
import { TakeItForASpin } from '@components/pages/FocusSections';
import Newsletter from '@components/landing/Newsletter';
import { getInnovation, innovationSite } from '@/data/pages';

/** Shared template for every product page under the Innovations menu. */
export default function Innovation() {
    const { slug } = useParams();
    const page = getInnovation(slug);

    if (!page) return <Navigate to="/404" replace />;

    return (
        <PageShell>
            <InnovationHero
                key={page.slug}
                titleLead={page.titleLead}
                titleBold={page.titleBold}
                intro={page.intro}
                logo={page.logo}
                label={page.label}
                href={innovationSite(page.slug)}
            />
            <InnovationAbout label={page.label} />
            <InnovationFeatures />
            <TakeItForASpin
                video={{
                    heading: 'Don’t just take our word for it – take it for a spin!',
                    copy: `${page.label} is already running. The quickest way to understand it is to watch someone use it end to end — the intake, the handoff, and what happens at the point a person would otherwise have given up.`,
                    thumbnail: '/focus/demo-video.webp',
                }}
            />
            <InnovationCTA label={page.label} href={innovationSite(page.slug)} />
            <Newsletter />
        </PageShell>
    );
}
